import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";

const initialState = {
    clientRates: [],
    loading: false,
    saving: false,
    deleting: false
};

export default function clientRate(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_CLIENT_RATE:
            newState.loading = true;
            break;

        case actions.SAVING_CLIENT_RATE:
            newState.saving = true;
            break;

        case actions.RECEIVED_CLIENT_RATES:
            newState.loading = false;
            newState.clientRates = utils.mapById(action.payload)
            break;

        case actions.SAVED_CLIENT_RATE:
            let found = false;

            for (let i = 0; i < newState.clientRates.length; i++) {
                if(newState.clientRates[i].id === action.payload.id){
                    found = true;

                    newState.clientRates[i] = action.payload;
                }
            }

            if(!found) {
                newState.clientRates.add(
                    action.payload
                );
            }

            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_CLIENT_RATES:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.DELETING_CLIENT_RATE:
            newState.deleting = true;
            break;

        case actions.DONE_DELETING_CLIENT_RATE:
            newState.deleting = false;
            break;

        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/clientRate.js